/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Import_Status_StartingInputs */

const en_iconik_import_status_starting = /** @type {(inputs: Iconik_Import_Status_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starting import...`)
};

const fr_iconik_import_status_starting = /** @type {(inputs: Iconik_Import_Status_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demarrage de l'importation...`)
};

const de_iconik_import_status_starting = /** @type {(inputs: Iconik_Import_Status_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import wird gestartet...`)
};

const it_iconik_import_status_starting = /** @type {(inputs: Iconik_Import_Status_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avvio importazione...`)
};

const ru_iconik_import_status_starting = /** @type {(inputs: Iconik_Import_Status_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Начало импорта...`)
};

const es_iconik_import_status_starting = /** @type {(inputs: Iconik_Import_Status_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciando importación...`)
};

const zh_cn2_iconik_import_status_starting = /** @type {(inputs: Iconik_Import_Status_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开始导入...`)
};

const ja_iconik_import_status_starting = /** @type {(inputs: Iconik_Import_Status_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`インポートを開始しています...`)
};

const hi_iconik_import_status_starting = /** @type {(inputs: Iconik_Import_Status_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आयात शुरू हो रहा है...`)
};

const pt_pt2_iconik_import_status_starting = /** @type {(inputs: Iconik_Import_Status_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciando a importação...`)
};

/**
* | output |
* | --- |
* | "Starting import..." |
*
* @param {Iconik_Import_Status_StartingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_import_status_starting = /** @type {((inputs?: Iconik_Import_Status_StartingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Import_Status_StartingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_iconik_import_status_starting(inputs)
	if (locale === "de") return de_iconik_import_status_starting(inputs)
	if (locale === "it") return it_iconik_import_status_starting(inputs)
	if (locale === "ru") return ru_iconik_import_status_starting(inputs)
	if (locale === "es") return es_iconik_import_status_starting(inputs)
	if (locale === "zh-CN") return zh_cn2_iconik_import_status_starting(inputs)
	if (locale === "ja") return ja_iconik_import_status_starting(inputs)
	if (locale === "hi") return hi_iconik_import_status_starting(inputs)
	if (locale === "pt-PT") return pt_pt2_iconik_import_status_starting(inputs)
	return en_iconik_import_status_starting(inputs)
});